import React from 'react';

const COLORS = {
  forestGreen: '#0F3D2E',
  deepGreen: '#003C3C',
  heritageGold: '#C9A14A',
  offWhite: '#FFFDF7',
  border: '#E4D7BC',
  danger: '#B54135',
  success: '#2F8F4E',
};

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'primary',
  loading = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  const isDanger = tone === 'danger';
  const isSuccess = tone === 'success';
  const accent = isDanger ? COLORS.danger : isSuccess ? COLORS.success : COLORS.heritageGold;

  return (
    <div style={styles.overlay} role="dialog" aria-modal="true">
      <div style={styles.dialog}>
        <div style={{ ...styles.icon, backgroundColor: `${accent}22`, color: accent }}>
          {isDanger ? '!' : isSuccess ? '✓' : '?'}
        </div>

        <h3 style={styles.title}>{title}</h3>
        <p style={styles.message}>{message}</p>

        <div style={styles.actions}>
          <button type="button" style={styles.cancelButton} onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button
            type="button"
            style={{
              ...styles.confirmButton,
              backgroundColor: accent,
              color: isDanger || isSuccess ? '#fff' : COLORS.deepGreen,
            }}
            onClick={onConfirm}
            disabled={loading}>
            {loading ? 'Working...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 2000,
    backgroundColor: 'rgba(15, 61, 46, 0.46)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  dialog: {
    width: 'min(440px, 100%)',
    backgroundColor: COLORS.offWhite,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    padding: 24,
    boxShadow: '0 24px 80px rgba(15, 61, 46, 0.28)',
  },
  icon: {
    width: 42,
    height: 42,
    borderRadius: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 900,
    fontSize: 20,
    marginBottom: 16,
  },
  title: {
    margin: 0,
    color: COLORS.forestGreen,
    fontSize: 22,
  },
  message: {
    margin: '10px 0 0',
    color: '#6E6254',
    lineHeight: 1.55,
    fontSize: 15,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
    marginTop: 24,
  },
  cancelButton: {
    border: `1px solid ${COLORS.border}`,
    backgroundColor: '#fff',
    color: COLORS.deepGreen,
    borderRadius: 4,
    padding: '10px 14px',
    fontWeight: 800,
    cursor: 'pointer',
  },
  confirmButton: {
    border: 'none',
    borderRadius: 4,
    padding: '10px 14px',
    fontWeight: 900,
    cursor: 'pointer',
    minWidth: 110,
  },
};
